<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.taskProperties}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="task.productTitle | safeHtml"></span>
	</h5>
</div>
<div class="dx-properties modal-body">
  <div style="max-height:600px;overflow-y:auto;overflow-x:hidden">
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.taskID}}</h4>
        <p class="truncate">{{task.taskId}}</p>
	</div>  
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.name}}</h4>
        <p class="truncate">{{task.taskName}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.title}}</h4>
		<p title="{{task.productTitle}}"
			class='dd-text-collapse' 
			ddTextCollapse
			[ddTextCollapseMaxLength]="80" 
			[ddTextCollapseText]="task.productTitle">
		</p>        
	</div>
	<div *ngIf="task.productMetadataDisplay && task.productMetadataDisplay.length > 0" class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.document}} {{LOCALIZATION.metadata}}</h4>
        <p>
	        <span *ngFor='let metadata of task.productMetadataDisplay' class="dx-product-metadata">
	            	<span class="dx-metadata-label">{{metadata.label}}:</span><span class="dx-metadata-value">{{metadata.value}}</span>
	        </span>
        </p>
        <p><a title="View the document metadata" (click)="viewProductMetadata()" class="pointMe">View Full Metadata</a></p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.pages}}</h4>
        <p>{{task.productPages}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.state}}</h4>
        <p>{{task.state}}</p>
	</div>	
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.status}}</h4>
        <p>{{task.jbpmStatus}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.priority}}</h4>
        <p [ngClass]="{'high-priority' : 'High' == task.priority}">{{task.priority}}</p>
	</div>
	<!-- div class="list-group-item">
		<h4 class="list-group-item-heading">Last Opened</h4>
        <p>{{task.lastOpenedDateStr}}</p>
	</div -->
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.dueDate}}</h4>
        <p>{{task.dueDateStr || LOCALIZATION.none}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.expiresDate}}</h4>
        <p>{{task.expirationDateStr || 'Never'}}</p>
	</div>	
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.createdDate}}</h4>
        <p>{{task.createdDateStr}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.owner}}</h4>
        <p>{{task.owner || LOCALIZATION.none}}</p>
	</div>		
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.batch}}</h4>
        <p>{{LOCALIZATION.name}}: {{task.batchName}} <br>{{LOCALIZATION.id}}: {{task.batchId}}</p>
	</div>
	<!-- div class="list-group-item">
		<h4 class="list-group-item-heading">Category</h4>
        <p *ngIf="task.category" class="truncate">{{task.category.name || LOCALIZATION.none}}</p>
	</div -->	
	<div [hidden]="(task.comments | isEmpty)" class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.comments}}</h4>
        <p *ngFor='let c of task.comments' class="dx-comment">
        	<span class="comment-date">{{c.commentDateStr}}</span>
        	<span class="comment-from" *ngIf="c.commentorId">({{c.commentorId}})</span>
        	<span class="comment-message">{{c.message}}</span>
        </p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.workflow}}</h4>
        <p>{{task.workflowType}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.description}}</h4>
        <p>{{task.description || LOCALIZATION.none}}</p>
	</div>
	<div *ngIf="task.productOCRScore" class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.ocrScore}}</h4>
        <p>{{task.productOCRScore}}</p>
	</div>
	<div class="list-group-item">
		<h4 class="list-group-item-heading">{{LOCALIZATION.uuid}}</h4>
        <p>{{task.productUUID}}</p>
	</div>
  </div>
</div>
<div class="modal-footer">
	 <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>
